/**
 * `total-vote` - the amount paid, by vote over the total and payment lines
 * (`findPaidTotal`): a receipt prints it several times, other totals once.
 *
 * Needs `text`, and reads the `lines` where there are any. Provides
 * `candidates:total`, with the line it was read from. No options.
 */

import { findPaidTotal, formatOre } from '../grounding.js';
import type { Candidate, Step } from '../types.js';
import { groundingLines } from './support.js';

export const totalVoteStep: Step<Record<string, never>> = {
  name: 'total-vote',
  needs: () => ['text'],
  provides: () => ['candidates:total'],
  async run(state, context) {
    const paid = findPaidTotal(groundingLines(state));
    if (!paid) return { skipped: 'no total or payment line' };
    const candidate: Candidate = { value: formatOre(paid.ore), source: context.id, evidence: [paid.lineIndex + 1] };
    return { candidates: { total: [candidate] }, added: [`total ${String(candidate.value)} (line ${paid.lineIndex + 1})`] };
  },
};
